interface Frontmatter {
  title: string;
  date: string;
  author: string;
  excerpt: string;
  tags: string[];
  image?: string;
  series?: string;
  seriesPart?: string;
}

interface ParsedMarkdown {
  frontmatter: Frontmatter;
  content: string;
}

export function parseFrontmatter(raw: string): ParsedMarkdown {
  const match = raw.match(/^---\r?\n([\s\S]*?)\r?\n---\r?\n([\s\S]*)$/);
  if (!match) {
    throw new Error('Invalid frontmatter format');
  }

  const [, frontmatterBlock, content] = match;
  const frontmatter: Record<string, string> = {};

  for (const line of frontmatterBlock.split('\n')) {
    const colonIndex = line.indexOf(':');
    if (colonIndex === -1) continue;
    const key = line.slice(0, colonIndex).trim();
    const value = line.slice(colonIndex + 1).trim();
    frontmatter[key] = value;
  }

  return {
    frontmatter: {
      title: frontmatter.title ?? '',
      date: frontmatter.date ?? '',
      author: frontmatter.author ?? '',
      excerpt: frontmatter.excerpt ?? '',
      tags: (frontmatter.tags ?? '').split(',').map(t => t.trim()).filter(Boolean),
      image: frontmatter.image || undefined,
      series: frontmatter.series || undefined,
      seriesPart: frontmatter.seriesPart || undefined,
    },
    content: content.trim(),
  };
}
